<template>
	<v-card>
		<v-card-title>
			<span class="text-body-1 font-weight-bold mr-3">Total Tokens</span>

			<v-btn icon :loading="loading" @click="loadTokens">
				<v-icon>mdi-reload</v-icon>
			</v-btn>
		</v-card-title>

		<v-card-text>
			<div v-if="loading">
				<v-progress-linear indeterminate />
			</div>
			<div class="d-flex align-center" style="gap: 1rem" v-else>
				<v-avatar class="rounded" size="67" color="yellow lighten-4" tile>
					<v-icon color="yellow darken-2"> mdi-cash </v-icon>
				</v-avatar>
				<div>
					<div class="grey--text" style="margin-top: 6px; font-size: 13px">Unused Tokens</div>
					<h2 class="black--text">
						{{ parseInt(this.tokens).toLocaleString() }}
					</h2>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
	data: () => ({
		tokens: 0,
		loading: false,
		url: process.env.VUE_APP_API_URL + 'dashboard/unused_tokens',
	}),

	computed: {
		...mapState(['userToken']),
	},

	methods: {
		async loadTokens() {
			try {
				this.loading = true
				const response = await fetch(`${this.url}`, {
					method: 'GET',
					headers: {
						Authorization: `Bearer ${this.userToken}`,
					},
				})

				const res = await response.json()

				if (!response.ok) throw { response, res }

				console.log(res)

				this.tokens = res
			} catch (error) {
				const errorStatus = error.response.status
				alert(errorStatus)
			} finally {
				this.loading = false
			}
		},
	},

	mounted() {
		this.loadTokens()
	},
}
</script>
